import { render, staticRenderFns } from "./uploadMaterial.vue?vue&type=template&id=35677030&scoped=true&"
import script from "./uploadMaterial.vue?vue&type=script&lang=js&"
export * from "./uploadMaterial.vue?vue&type=script&lang=js&"
import style0 from "./uploadMaterial.vue?vue&type=style&index=0&id=35677030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35677030",
  null
  
)

export default component.exports